// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8068bf98","732":"63ef2520","977":"caf28a25"}[chunkId] + ".chunk.js";
};